import { TThunkAction } from '../../types/redux/thunk';
import { ERequestApiStatus } from '../../types/widgetState';

/**
 * Не удалось установить сессию после четырёх попыток
 */
export const registerWsSessionFailed =
  (): TThunkAction<void> =>
  (dispatch, getState, { custom: { socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents } = socket;

    for (const [key, value] of clientEvents.entries()) {
      if (value.status === ERequestApiStatus.Pending) {
        clientEvents.set(key, { ...value, status: ERequestApiStatus.Failed });
      }
    }
  };
